import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessDefinitionEntity } from './process-definition.entity';
import { ProcessTaskHistoryEntity } from './process-task-history.entity';
import { ProcessTaskEntity } from './process-task.entity';

@Index(
	'process_task_definition__fk_process_definition__id_fk',
	['fkProcessDefinitionId'],
	{},
)
@Entity('process_task_definition')
export class ProcessTaskDefinitionEntity extends BaseEntity {
	@Column('int', { name: '_fk_process_definition__id', unsigned: true })
	public fkProcessDefinitionId!: number;

	@Column('int', { name: 'ordinal' })
	public ordinal!: number;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@OneToMany(
		() => ProcessTaskEntity,
		(processTask) => processTask.fkProcessTaskDefinition,
		{},
	)
	public processTasks!: Array<ProcessTaskEntity>;

	@ManyToOne(
		() => ProcessDefinitionEntity,
		(processDefinition) => processDefinition.processTaskDefinitions,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessDefinition!: ProcessDefinitionEntity;

	@OneToMany(
		() => ProcessTaskHistoryEntity,
		(processTaskHistory) => processTaskHistory.fkProcessTaskDefinition,
		{},
	)
	public processTaskHistories!: Array<ProcessTaskHistoryEntity>;
}
